import React from 'react';

import { Button, Grid } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';

import { authValidationSchema } from './schema';

const LOGIN = 'login';
const PASSWORD = 'password';

const LegacySignInForm = withForm({
  validationSchema: authValidationSchema,
  enableReinitialize: true,
})(({ handleSubmit, values, setValues, submitForm }) => {
  const handleClick = () => {
    const loginInput = document.querySelector(`input[name=${LOGIN}]`);
    const passwordInput = document.querySelector(`input[name=${PASSWORD}]`);
    if (loginInput.value && passwordInput.value) {
      if (!values.login && !values.password) {
        setValues({
          [LOGIN]: loginInput?.value,
          [PASSWORD]: passwordInput?.value,
        });
        submitForm();
      }
    }
  };
  return (
    <form onSubmit={handleSubmit} action={'#'}>
      <Grid item container spacing={3}>
        <Grid item xs={12}>
          <FormField.TextField
            width={'100%'}
            name={LOGIN}
            label={'Login'}
            variant={'outlined'}
            data-cy={'loginId'}
            padding={0}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField.TextField
            width={'100%'}
            name={PASSWORD}
            label={'Password'}
            variant={'outlined'}
            type={'password'}
            data-cy={'passwordId'}
            padding={0}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            style={{ width: '100%' }}
            variant={'contained'}
            type={'submit'}
            data-cy={'submitId'}
            onClick={handleClick}
          >
            Login
          </Button>
        </Grid>
      </Grid>
    </form>
  );
});
export default LegacySignInForm;
